import { QueryParam } from "../../../types/api/generic.type";
import { GetHistoryProjectSectorResponse } from "../../../types/api/projects.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const HistoryProjectSectorService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetHistoryProjectSectorResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response = await httpClient.get<GetHistoryProjectSectorResponse>(
      `v1/history/project-sectors?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
};

export default HistoryProjectSectorService;
